import { render, staticRenderFns } from "./SecondCheck.vue?vue&type=template&id=16ac4c28&scoped=true";
import script from "./SecondCheck.vue?vue&type=script&lang=js";
export * from "./SecondCheck.vue?vue&type=script&lang=js";
import style0 from "./SecondCheck.vue?vue&type=style&index=0&id=16ac4c28&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "16ac4c28", null);
export default component.exports;